"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GemsEffect = void 0;
var GemsEffect = /** @class */ (function (_super) {
    __extends(GemsEffect, _super);
    function GemsEffect(scene, startX, startY, endX, endY) {
        var _this = _super.call(this, scene) || this;
        var t = 850;
        var n = 8;
        var _loop_1 = function (i) {
            var dx = 10 - 20 * Math.random();
            var dy = 10 - 20 * Math.random();
            var gemEffect = new Phaser.GameObjects.Sprite(this_1.scene, startX + dx, startY + dy, "texture_atlas_1", "fx_particles_radial_01");
            this_1.scene.add.existing(gemEffect);
            gemEffect.play("gem-fx");
            gemEffect.setScale(.8 + .2 * Math.random());
            gemEffect.angle = 360 * Math.random();
            this_1.add(gemEffect);
            this_1.scene.tweens.add({
                targets: gemEffect,
                x: endX,
                y: endY,
                scaleX: .35,
                scaleY: .35,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: t + 25 * i,
                delay: 250 + 25 * i,
                onComplete: function () {
                    gemEffect.destroy();
                    this.i++;
                    if (this.i === n) {
                        this.destroy();
                    }
                },
                onCompleteScope: this_1
            });
        };
        var this_1 = this;
        for (var i = 0; i < n; i++) {
            _loop_1(i);
        }
        return _this;
    }
    return GemsEffect;
}(Phaser.GameObjects.Container));
exports.GemsEffect = GemsEffect;
